'use client';

import NextLink from 'next/link';

import { createAppLink } from '@naumu/platform-client/app-link';

/**
 * Marketing-side binding of the shared cross-app link (see
 * `@naumu/platform-client/app-link` for why platform hrefs render an anchor).
 *
 * `AppLink` is the direct-import replacement for `next/link`; `NextLinkBridge`
 * applies the same rule to every DS component that renders through `UiLink`.
 */
export const { AppLink, NextLinkBridge } = createAppLink({ side: 'marketing', Link: NextLink });
